import React, { useState } from 'react';
import type { ISetConsentRequestBody } from 'src/api/types/self-service/set-consent';
import Checkbox from '../../checkbox/checkbox';
import type { IToastProps } from '../../toast/toast';
import Toast, { ToastType } from '../../toast/toast';

export interface IConsentItemProps {
    header: string;
    type: string;
    isSelected: boolean;
    checkLabel: string;
    consentText: string;
}

export default function ConsentItem(props: IConsentItemProps) {
    const [toast, setToast] = useState<IToastProps>({ title: '', message: '', type: ToastType.success });
    const [showToast, setShowToast] = useState(false);

    const createToast = (succes: boolean, checked: boolean): IToastProps => {
        const succesMessage = checked ? 'Du er tilmeldt' : 'Du er frameldt';

        return {
            title: succes ? 'Tak' : 'Desværre',
            message: succes ? succesMessage : 'Noget er gået galt, prøv igen senere',
            type: succes ? ToastType.success : ToastType.error,
        };
    };

    const onTap = async (checked: boolean) => {
        try {
            const data = await updateConsent(checked);

            setToast(createToast(data, checked));
        } catch (_err) {
            setToast(createToast(false, checked));
        }

        setShowToast(true);
    };

    const updateConsent = async (checked: boolean) => {
        const requestBody: ISetConsentRequestBody = { Enabled: checked, Id: `consent-${props.type}` };
        const response = await fetch("/SelfServiceApi/SetConsent", {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
            throw new Error();
        }

        return response.json() as Promise<boolean>;
    };

    return (
        <>
            <div className="consent-item">
                <div className="consent-item__title">{props.header}</div>
                <div className="consent-item__checkbox">
                    <Checkbox
                        checked={props.isSelected ?? false}
                        label={props.checkLabel}
                        id={props.type}
                        name={props.checkLabel}
                        onChange={onTap}
                    />
                </div>
                <div
                    className="consent-item__content rich-text-styling-dark"
                    dangerouslySetInnerHTML={{ __html: props.consentText }}
                />
                <div className="consent-item__separator"></div>
            </div>
            {showToast && (
                <Toast
                    title={toast.title}
                    message={toast.message}
                    type={toast.type}
                    onClose={() => {
                        setShowToast(false);
                    }}
                />
            )}
        </>
    );
}
